import { sortMembersByType } from '@atlassian/teams-client';
import {
	type TeamMembership,
	type TeamWithImageUrls,
	type User,
} from '@atlassian/teams-client/types';

import type { StoreApi, TeamAppState as TeamState } from '../../types';
import { getMyTeamMembership } from '../get-my-team-membership';
import { getTeamMembers } from '../get-team-members';

const TIMEOUT_DELAY = 5000;

function membershipMaker(teamId: string) {
	return (user: User): TeamMembership => {
		return {
			membershipId: {
				teamId,
				memberId: user.id,
			},
			state: 'FULL_MEMBER',
			role: 'REGULAR',
			user,
		};
	};
}

export const prefillTeamData =
	(teamId: string, teamData: TeamWithImageUrls, members: User[], currentUser: User) =>
	({ getState, setState, dispatch }: StoreApi) => {
		const newState: TeamState = {
			...getState(),
			teamProfile: {
				teamId,
				isLoading: false,
				hasLoaded: true,
				errorType: null,
				data: teamData,
			},
			teamMembers: {
				teamId,
				isLoading: false,
				isLoadingNextPage: false,
				hasLoaded: true,
				hasError: false,
				errorType: null,
				members: sortMembersByType(members.map(membershipMaker(teamId)), currentUser.id),
				requestingToJoinUsers: [],
				membersPageInfo: { hasNextPage: false, cursor: null },
				requestingToJoinUsersPageInfo: { hasNextPage: false, cursor: null },
			},
			myTeamMembership: {
				teamId,
				hasLoaded: true,
				membership: members.some((x) => x.id === currentUser.id)
					? membershipMaker(teamId)(currentUser)
					: undefined,
			},
		};

		setState(newState);

		setTimeout(() => {
			if (getState().teamProfile.teamId !== teamId) {
				return;
			}

			void dispatch(getTeamMembers(teamId, true));
			void dispatch(getMyTeamMembership(teamId, true));
		}, TIMEOUT_DELAY);
	};
